import styled from 'styled-components';

import { List } from 'components/list';

// Below desktop only the long Expenses list scrolls inside a 352px box. The
// Revenue list (one row per day + Missing sales) shows all its rows: on a
// phone a row card is 200px, so a capped box left a 151px scroll window.
export const StyledList = styled(List)<{ $isExpenses?: boolean }>`
  flex: 1;
  height: 100%;
  min-height: 0;
  max-height: ${({ theme, $isExpenses }) =>
    !theme.responsive.isDesktop && $isExpenses ? '352px' : 'unset'};
`;
